import { normalizeNumber } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_SIGN_INTENT_VALID_SAMPLE_RATE = createFcmConfig('sign_intent_valid_sample_rate', {
	normalizer: normalizeNumber,
	defaultValue: 15,
});
